import React, { FC, useState, useEffect, useRef, Ref } from 'react';
import { LabelValidator } from '../input/label-validador';
import { TextAreaProps } from './props';
import { Container, StyledTextArea, StyledLabel } from './styles';

export const TextArea: FC<TextAreaProps> = ({
    label,
    color = '#47516f',
    style,
    value,
    isValid,
    onChange,
    ...rest
}) => {
    const ref: Ref<HTMLTextAreaElement> = useRef(null); 
    const [text, setText] = useState(value || '');
    const [focused, setFocused] = useState(false);

    useEffect(() => {
        if (ref.current) {
            ref.current.onfocus = () => setFocused(true);
            ref.current.onblur = () => setFocused(false);
        }
    }, [ref]);

    useEffect(() => {
        ref.current?.addEventListener('keydown', autosize);
        autosize();

        return () => {
            ref.current?.removeEventListener('keydown', autosize);
        }
    }, [])

    const autosize = () => {
        setTimeout(() => {
            if (!ref || !ref.current) return;

            ref.current.style.cssText = 'height:auto;';
            ref.current.style.cssText = 'height:' + ref.current.scrollHeight + 'px';
        }, 0);
    }

    useEffect(() => {
        setText(value || '');
    }, [value]);

    return (
        <Container style={style}>
            <StyledTextArea
                {...rest}
                isValid={isValid}
                type='text'
                value={text}
                ref={ref}
                onChange={(ev: any) => {
                    setText(ev.target.value);
                    return onChange?.(ev);
                }}
                className={`luk-textarea ${rest.className || ''}`}
                placeholder=''
            />
            <StyledLabel active={focused || text !== ''}>
                {label}
            </StyledLabel>
            <LabelValidator isValid={isValid} />
        </Container>
    );
};
